import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, Paper, TextField, Button, Grid } from '@mui/material';

const Igreja = () => {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ local: '', data: '', horario: '', valor_locacao: '', observacoes: '' });
  const [editId, setEditId] = useState(null);

  const fetchData = async () => {
    const res = await axios.get('/api/igreja');
    setDados(res.data);
  };

  useEffect(() => { fetchData(); }, []);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    if (editId) {
      await axios.put(`/api/igreja/${editId}`, form);
    } else {
      await axios.post('/api/igreja', form);
    }
    setForm({ local: '', data: '', horario: '', valor_locacao: '', observacoes: '' });
    setEditId(null);
    fetchData();
  };

  const handleEdit = item => {
    setForm(item);
    setEditId(item.id);
  };

  const handleDelete = async id => {
    await axios.delete(`/api/igreja/${id}`);
    fetchData();
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Igreja</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField label="Local" name="local" value={form.local} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Data" name="data" value={form.data} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Horário" name="horario" value={form.horario} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Valor Locação" name="valor_locacao" value={form.valor_locacao} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Observações" name="observacoes" value={form.observacoes} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={12}><Button type="submit" variant="contained">{editId ? 'Salvar' : 'Adicionar'}</Button></Grid>
          </Grid>
        </form>
      </Paper>
      {dados.map(item => (
        <Paper key={item.id} sx={{ p: 2, mb: 1 }}>
          <Typography><b>Local:</b> {item.local}</Typography>
          <Typography><b>Data:</b> {item.data}</Typography>
          <Typography><b>Horário:</b> {item.horario}</Typography>
          <Typography><b>Valor Locação:</b> R$ {item.valor_locacao}</Typography>
          <Typography><b>Observações:</b> {item.observacoes}</Typography>
          <Button onClick={() => handleEdit(item)} sx={{ mr: 1 }}>Editar</Button>
          <Button color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
        </Paper>
      ))}
    </Container>
  );
};

export default Igreja;
